import { getAuthHeaders } from '../utils/authHeaders';
import { getCurrentGatewayUrl } from '../utils/environmentDetection';

export type CoPilotTraceSummaryEvidence = {
  toolExecutionHarId: string;
  explanation: string;
  whyItMatters?: string;
};

export type CoPilotTraceSummaryResponse = {
  summary: string;
  evidences: CoPilotTraceSummaryEvidence[];
};

export async function loadCoPilotTraceSummary({
  threadId,
  targetId,
}: {
  threadId: string;
  targetId?: string;
}): Promise<CoPilotTraceSummaryResponse> {
  const authHeaders = await getAuthHeaders();
  const query = new URLSearchParams(targetId ? { targetId } : {});
  const querySuffix = query.size > 0 ? `?${query.toString()}` : '';

  const response = await fetch(
    `${getCurrentGatewayUrl()}/chat/conversation/thread/${threadId}/trace-summary${querySuffix}`,
    {
      method: 'GET',
      credentials: 'include',
      headers: authHeaders,
    },
  );

  if (!response.ok) {
    throw new Error(
      `Co-pilot trace summary request failed with status ${response.status}`,
    );
  }

  return (await response.json()) as CoPilotTraceSummaryResponse;
}
